module.exports = __webpack_public_path__ + "img/njm_g2-84.prt.f0799893.jpg";